import React, { useState } from "react";
import { Collapse } from "reactstrap";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import { procesarPrecio } from "utils/funciones";

const ResumenDatosSeguro = ({ datosTarifacion, codProducto }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <React.Fragment>
      <h2 className="font-mex mt-4 mb-3 text-mex" style={{ fontSize: "26px" }}>
        Descripción de pago
      </h2>

      <div className="row justify-content-between mb-3">
        <div className="col-6">
          <h5 className="font-source-sans-regular" style={{ fontSize: "20px" }}>
            Prima neta anual
          </h5>
        </div>
        <div className="col-6 text-right">
          <h5 style={{ fontSize: "20px" }}>
            {codProducto === PRODUCTOS.CASUALITY ||
            codProducto === PRODUCTOS.CASUALITY_GENERAL
              ? `$${datosTarifacion.primaNetaFormato}`
              : procesarPrecio(
                  datosTarifacion.primaNeta,
                  datosTarifacion.monedaSimbolo
                )}
          </h5>
        </div>
      </div>

      <div className="row justify-content-between my-2">
        {codProducto !== "AUTO" && (
          <div className="col-8">
            <h6 className="text-mex" style={{ fontSize: "26px" }}>
              Cargos Extras
            </h6>
          </div>
        )}
        {codProducto !== "AUTO" && (
          <div className="col-4 text-right">
            <h6
              className="prima-valores font-weight-bold"
              style={{ fontSize: "19px" }}
            >
              {codProducto === PRODUCTOS.CASUALITY ||
              codProducto === PRODUCTOS.CASUALITY_GENERAL
                ? `$${datosTarifacion.impuestosTotalFormato}`
                : procesarPrecio(
                    datosTarifacion.impuestosTotal,
                    datosTarifacion.monedaSimbolo
                  )}
            </h6>
          </div>
        )}

        <div className="col-12">
          {datosTarifacion.impuestosGenerados
            .sort((imp1, imp2) => imp1.orden - imp2.orden)
            .map((imp, index) => (
              <div className="row " key={index}>
                <div className="col-6">
                  <p
                    className={
                      codProducto !== "AUTO"
                        ? "font-source-sans-regular ml-4"
                        : "font-source-sans-regular"
                    }
                    style={{ fontSize: "20px" }}
                  >
                    {imp.impCodigo === "derecho"
                      ? "Derechos de póliza"
                      : imp?.impuestoNom}
                  </p>
                </div>
                <div className="col-6 text-right">
                  <p
                    className="font-source-sans-regular"
                    style={{ fontSize: "20px" }}
                  >
                    {procesarPrecio(
                      imp.impuestoValor,
                      datosTarifacion.monedaSimbolo
                    )}
                  </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    { codProducto === PRODUCTOS.SEGUKIDS && (<div className="row">
        <div className="col-6">
          <h6 className="text-mex" style={{ fontSize: "26px" }}>
            Forma de pago
          </h6>
        </div>
        <div className="col-6 text-right">
          <h6
            className="prima-valores font-weight-bold"
            style={{ fontSize: "20px" }}
          >
            {datosTarifacion.labelPlazo}
          </h6>
        </div>
      </div>)}

      <div className="row">       
        <div className="col-6">
          <h6 className="text-mex" style={{ fontSize: "26px" }}>
            Total a pagar
          </h6>
        </div>
        <div className="col-6 text-right">
          <h6
            className="prima-valores font-weight-bold"
            style={{ fontSize: "19px" }}
          >
            {codProducto === PRODUCTOS.CASUALITY ||
            codProducto === PRODUCTOS.CASUALITY_GENERAL
              ? `$${datosTarifacion.primaTotalFormato}`
              : procesarPrecio(
                  datosTarifacion.primaTotal,
                  datosTarifacion.monedaSimbolo
                )}
          </h6>
        </div>
      </div>

      {datosTarifacion.planPagos.length > 0 && (
        <div className="row justify-content-center">
          <div className="col-12">
            <h4 className="cpointer" onClick={toggle}>
              Detalle de pagos <i className="pi pi-chevron-down" />
            </h4>
            <Collapse isOpen={isOpen}>
              {datosTarifacion?.planPagos?.map((e, index) => (
                <div className="w-100" key={index * 123}>
                  <p className="d-inline ml-2" style={{ fontSize: "20px" }}>
                    {e.labelPago}
                  </p>
                  <p
                    className="float-right"
                    style={{ fontSize: "20px" }}
                  >{` $${e.primaTotal} ${datosTarifacion.monedaSimbolo}`}</p>
                </div>
              ))}
            </Collapse>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default ResumenDatosSeguro;
